import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@one-thd/sui-atomic-components';

const RelatedLinks = ({ relatedLinks = [] }) => {
  if (!relatedLinks || relatedLinks.length === 0) return null;

  return (
    <div className="sui-flex sui-gap-2 sui-overflow-x-auto sui-whitespace-nowrap">
      {relatedLinks.map((link, index) => (
        <div key={link?.categoryId} className="sui-flex sui-gap-2">
          {index > 0 && <span aria-hidden="true">|</span>}
          <Link href={link?.canonicalUrl}>{link?.pageTitle}</Link>
        </div>
      ))}
    </div>
  );
};

RelatedLinks.propTypes = {
  relatedLinks: PropTypes.arrayOf(
    PropTypes.shape({
      canonicalUrl: PropTypes.string.isRequired,
      pageTitle: PropTypes.string.isRequired,
      categoryId: PropTypes.string.isRequired
    })
  )
};

RelatedLinks.displayName = 'RelatedLinks';

export { RelatedLinks };